<script setup lang="ts">
const props = defineProps({
	color: {
		type: String,
		default: '',
	},
	width: {
		type: String,
		default: '20',
	},
	height: {
		type: String,
		default: '20',
	},
});
const color = computed(() => props.color);
const { color: iconColor } = useIconColor(color);

</script>
<template>
  <svg
    :width="width"
    :height="height"
    :viewBox="`0 0 ${width} ${height}`"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="currency-ethereum-circle">
      <path
        id="Icon"
        d="M5.9165 12.916L10.5 14.9993L15.0832 12.916M18.8332 9.99935C18.8332 14.6017 15.1022 18.3327 10.4998 18.3327C5.89746 18.3327 2.1665 14.6017 2.1665 9.99935C2.1665 5.39698 5.89746 1.66602 10.4998 1.66602C15.1022 1.66602 18.8332 5.39698 18.8332 9.99935ZM5.9165 9.58268L10.5 11.666L15.0832 9.58268L10.5 4.16602L5.9165 9.58268Z"
        :stroke="iconColor"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>
